module.exports = __webpack_public_path__ + "img/complyon_logo.67ddcd95.svg";